<template>
  <div class="c-timer-modal">
    <div class="message">
      <div class="message-container">
        <div class="title">Замер времени</div>
        <div class="buttons">
          <n-button flat class="modal-button agree" @click="agree">Да</n-button>
          <n-button flat class="modal-button cancel" @click="close">Нет</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CModalMessage',
  props: {

  },
  data() {
    return {
    }
  },
  methods: {
    agree() {
      this.$emit('agree')
      this.close()
    },
    close() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped lang="scss">
.c-timer-modal {
  position: absolute;
  display: flex;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .2);
  align-items: center;
  justify-content: center;

  .message {
    position: absolute;
    display: flex;
    background-color: #ffffff;
    border-radius: 16px;
    width: 435px;
    .message-container {
      padding: 15px;
      display: flex;
      .buttons {
        display: flex;
        justify-content: space-between;
        .modal-button {
          width: 145px;
          height: 45px;
          background-color: #F2F3F7;
          border-radius: 8px;
          font-weight: bold;
          font-size: 1.05em;
          &.agree {
            color: #DB0007;
            margin-right: 12px;
          }
          &.cancel {
            color: var(--secondary)
          }
        }
      }
    }
  }
}
.close-modal {
  display: none;
}
</style>
